import { useSelector, useDispatch } from "react-redux";
import { StyledButton } from "../../components/styled/styled-components";
import { CurrentOrder } from "../../redux/reducers/orders";
import { RootState } from "../../redux/store";
import { findNumberOfInvalidProducts } from "./utils/productUtils";
import addItems from "./fetchs/addItems";
import { AlertType } from "../../interfaces/enums";
import { updateCurrentOrder } from "../../redux/actions/orders";
import getCurrentOrder from "./fetchs/getCurrentOrder";
import { useOrderUploaderContext } from "./context/OrderUploaderContext";

const AddToCart = () => {
  const { fetchedProducts, setToast, setModalToShow, setFetchedProducts } =
    useOrderUploaderContext();
  const currentOrder: CurrentOrder = useSelector((state: RootState) => state.orders.currentOrder);
  const dispatch = useDispatch();

  const handleOnClick = async () => {
    const numInvalidProducts = findNumberOfInvalidProducts(fetchedProducts);
    if (numInvalidProducts > 0) {
      setToast({
        type: AlertType.Error,
        message: "To proceed, please remove the invalid products",
      });
      return;
    }

    if (currentOrder && currentOrder.order_items && currentOrder.order_items.length > 0) {
      setModalToShow("clearCart");
      return;
    }

    setModalToShow("addingToCart");
    const response = await addItems(fetchedProducts);
    setModalToShow(null);

    if (response.status !== 200) {
      setToast({
        type: AlertType.Error,
        message: response.message,
      });
    } else {
      setModalToShow("goToCart");
      setFetchedProducts([]);
    }

    // Update the cart in the header by fetching the current order
    const currentOrderData = await getCurrentOrder();
    dispatch(updateCurrentOrder(currentOrderData));
  };

  return (
    <div className="util">
      <StyledButton onClick={() => handleOnClick()}>Add to Cart</StyledButton>
    </div>
  );
};

export default AddToCart;
